import React from "react"
import "../styles/footer.scss"

export default () => {
  return (
		<>
			<footer>
				<div class="global-footer">© 2020 rutko</div>
			</footer>
		</>
	);
}